import Vue from "vue";
import VueClipboard from "vue-clipboard2";

import { formatDate, formatDollar } from "@/filters";
import VueQrcode from "@chenfengyuan/vue-qrcode";
import { serverBus } from "@/main";

Vue.use(VueClipboard);
Vue.component(VueQrcode.name, VueQrcode);
export default {
  data() {
    return {
      type: "",
      loading: false,
      items: [],
      modal: false,
      invoice: {},
      selected: "all"
    };
  },
  filters: { formatDate, formatDollar },
  mounted() {
    this.getData();
  },
  computed: {
    itemsFiltered() {
      let result = this.items;
      if (this.selected !== "all")
        result = this.items.filter(f => f.invoice_status === this.selected);
      return result;
    }
  },
  methods: {
    onCopy() {
      this.$notify({
        type: "danger",
        message: "Copied !"
      });
    },
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/leads", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          }
        })
        .then(response => {
          this.items = response.data;
          this.loading = false;
        })
        .catch(error => {
          error.response.data &&
            error.response.data.map(m => {
              this.$notify({
                type: "danger",
                message: m
              });
            });
          this.loading = false;
        });
    },
    setInvoice(object) {
      serverBus.$emit("invoicePaymentModal", object);
    }
  }
};
